import DetailCardBody from '@/common/components/DetailCard/DetailCardBody.tsx';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems.tsx';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard.tsx';
import { IncidentDetailsMainCardProps } from '@/modules/adjusterReportModules/IncidentDetails/components/incidentDetails/IncidentDetailMainDetailCard.types';
import IncidentDetailsMainCardHeader from '@/modules/adjusterReportModules/IncidentDetails/components/incidentDetails/IncidentDetailsMainCardHeader';
import { css } from 'styled-system/css';

const IncidentDetailMainDetailCard = ({
  fileNumber,
  backgroundColor,
  hasBullet,
  items,
  fileType,
  svgColor,
  headerClassName,
}: IncidentDetailsMainCardProps) => {
  return (
    <MainDetailCard
      className={css({ borderColor: `${backgroundColor}`, borderWidth: '1px' })}
    >
      <IncidentDetailsMainCardHeader
        fileNumber={fileNumber}
        fileType={fileType}
        svgColor={svgColor}
        className={headerClassName}
      />
      <DetailCardBody>
        <DetailCardItems
          items={items?.filter((item) => item?.keyName !== 'محل وقوع حادثه')}
          hasBullet={hasBullet}
          backgroundColor={backgroundColor}
        />
      </DetailCardBody>
    </MainDetailCard>
  );
};

export default IncidentDetailMainDetailCard;
